import { AutocompleteProps } from "@mui/material";
import { useGetTractorListQuery } from "../../../../../graphql/generated";
import { ConditionValueSelectorComponentProps } from "../../ConditionForm";
import TractorInput from "./TractorInput";

type TractorInputContainerProps = ConditionValueSelectorComponentProps;

const TractorInputContainer = ({
  ...props
}: TractorInputContainerProps &
  Pick<AutocompleteProps<string, true, undefined, undefined>, "sx">) => {
  const query = useGetTractorListQuery({ includeInactive: true });
  return <TractorInput {...props} tractors={query.data?.tractors.data || []} />;
};

export default TractorInputContainer;
